<script setup>
const { data: upcomingWebinars } = useNuxtData("upcoming-webinars");
console.log('upcomingWebinars', upcomingWebinars)
</script>

<template>
  <div class="grid grid-cols-12 gap-5">
    <div class="md:col-span-6 col-span-12" v-for="webinar in upcomingWebinars" :key="webinar.id">
      <WebinarCard :webinar="webinar" />
    </div>
  </div>
</template>
